import React from 'react';
import { theme } from 'config/theme';
import Building4LineIcon from 'remixicon-react/Building4LineIcon';
import EarthLineIcon from 'remixicon-react/EarthLineIcon';
import MapLineIcon from 'remixicon-react/MapLineIcon';

type TaskApplicableToIconProps = {
  applicableTo: string;
  size?: number;
};

const IMPACT_COLORS = {
  Local: theme.palette.custom.mangoTango,
  Region: theme.palette.custom.greenishTeal,
  Global: theme.palette.custom.dodgerBlue,
};

const TaskApplicableToIcon: React.FC<TaskApplicableToIconProps> = ({ applicableTo, size = 16 }) => {
  switch (applicableTo.toLowerCase()) {
    case 'global':
      return <EarthLineIcon size={size} color={IMPACT_COLORS.Global} />;
    case 'region':
      return <MapLineIcon size={size} color={IMPACT_COLORS.Region} />;
    case 'local':
    default:
      return <Building4LineIcon size={size} color={IMPACT_COLORS.Local} />;
  }
};

export default TaskApplicableToIcon;
